module.exports = __webpack_public_path__ + "static/joy2-82ceec5f80d786ac189832634b5008e7.png";